import { createMuiTheme } from "@material-ui/core/styles";
var quizzesTheme = createMuiTheme();
export default quizzesTheme;